import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './index.scss';
import styled from 'styled-components';
import { capitalize } from 'lodash';

export const getAlertRadioOptions = (alertLevels = []) => {
  return alertLevels.map(({ code, displayName, color }) => ({
    label: displayName || capitalize(code),
    value: code,
    component: <StyledRadioItem color={color} />
  }));
};

const StyledRadioItem = styled.div`
  &&& {
    display: block;
    border: 1px solid transparent;
    border-radius: 8px;
    width: 13px;
    height: 8px;
    padding: 0 !important;
    margin-right: 6px;
    background: ${(props) => props.color};

    &:hover {
      border: 1px solid #ffffff;
    }
  }
`;

export const durationRadioOptions = [
  {
    label: '7 Days',
    value: '7'
  },
  {
    label: '30 Days',
    value: '30'
  },
  {
    label: '90 Days',
    value: '90'
  },
  {
    label: '180 Days',
    value: '180'
  },
  {
    label: '360 Days',
    value: '360'
  }
];

export const RadioButttonWithIcons = ({
  options,
  defaultValue,
  onChangeHandler
}) => {
  const [value, setvalue] = useState(defaultValue);

  useEffect(() => {
    if (defaultValue === '' || defaultValue === null) {
      setvalue('');
    }
  }, [defaultValue]);

  const onClickHandler = (item) => {
    setvalue(item.value);
    if (value !== item.value) onChangeHandler(item.value);
  };

  return (
    <div className={styles.radioWrapper}>
      {options.length > 0
        ? options.map((item, idx) => {
            return (
              <div
                key={idx}
                id={`radioBtn-${item.label}`}
                onClick={() => onClickHandler(item)}
                className={classnames(styles.radioInput, 'radioInput', {
                  [styles['selected']]: item.value == value
                })}>
                {item?.component !== undefined && item?.component} {item.label}
              </div>
            );
          })
        : null}
    </div>
  );
};

RadioButttonWithIcons.propTypes = {
  options: PropTypes.array.isRequired,
  defaultValue: PropTypes.string,
  onChangeHandler: PropTypes.func
};

export default RadioButttonWithIcons;
